import { render, staticRenderFns } from "./RefreshAnAccessToken.vue?vue&type=template&id=1964fa7d&scoped=true"
import script from "./RefreshAnAccessToken.vue?vue&type=script&lang=js"
export * from "./RefreshAnAccessToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964fa7d",
  null
  
)

export default component.exports